(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('MiscService', MiscService);

    MiscService.$inject = ['moment'];

    function MiscService(moment) {
        return {
            returnCropYears: returnCropYears,
            returnShipmentPeriods: returnShipmentPeriods,
            returnPricingYears: returnPricingYears,
            returnPlannerYears: returnPlannerYears,
            buildQualityDisplay: buildQualityDisplay,
            buildQtyDisplay: buildQtyDisplay,
            buildShipmentMonths: buildShipmentMonths,
            toFixed: toFixed,
            nl2br: nl2br,
            dateFix: dateFix,
            generateStartDate: generateStartDate,
            generateEndDate: generateEndDate,
            onStartDateChange: onStartDateChange,
            generateLastDayOfMonth: generateLastDayOfMonth,
            resolveDateStringByFormat: resolveDateStringByFormat
        };

        function buildShipmentMonths() {
            var shipmentMonths = [];

            var thisDay = moment();
            for(var i=0; i<12; i++) {

                thisDay.add(1, 'M');
                var m = thisDay.format("MMM");
                var yr = thisDay.format("YY");
                var rd = thisDay.toDate();
                shipmentMonths.push( {period: m + ' ' + yr, dateValue: rd });
            }
            return shipmentMonths;
        }

        function returnCropYears() {
            var cropYears = [];
            var cYear = new Date().getFullYear().toString();
            cYear = cYear.slice(2, 4);
            //last year
            var y1 = parseInt(cYear) - 2;
            var y2 = parseInt(cYear) - 1;
            var cropYear = y1 + "/" + y2;
            cropYears.push({year: cropYear, active: false});

            y1 = parseInt(cYear) - 1;
            y2 = parseInt(cYear);
            cropYear = y1 + "/" + y2;
            cropYears.push({year: cropYear, active: false});

            //current/succeeding years
            for (var x = 0; x < 5; x++) {
                y1 = parseInt(cYear) + parseInt(x);
                y2 = parseInt(cYear) + parseInt(x) + 1;
                cropYear = y1 + "/" + y2;
                cropYears.push({year: cropYear, active: false});
            }
            return cropYears;
        }

        function returnPricingYears() {
            var pricingYears = [];
            var cYear = new Date().getFullYear();
            //last years
            var lYear = cYear - 1;
            pricingYears.push( lYear );
            //current/succeeding years
            for( var x = 0; x < 5; x++ ) {
                var y = cYear + x;
                pricingYears.push( y );
            }
            return pricingYears;

        }

        function returnPlannerYears() {
            var plannerYears = [];
            var cYear = new Date().getFullYear();
            // last years
            for (var x = 2; x > 0; x--) {
                var y = cYear - x;
                plannerYears.push(y);
            }
            // current & succeeding years
            for (var x = 0; x <= 3; x++) {
                var y = cYear + x;
                plannerYears.push(y);
            }
            return plannerYears;
        }

        function returnShipmentPeriods() {

            var sPeriods = [];
            var thisMin = moment([]);

            var firstMonth = thisMin.subtract(1, 'months').format('MMM YY');
            sPeriods.push( firstMonth );
            for( var i=1; i<=12; i++) {
                sPeriods.push( thisMin.add(1, 'months').format('MMM YY') );
            }
            return sPeriods;

        }

        function buildQualityDisplay(grade, leaf, staple, mic, strength, strengthRange, unf, range) {
            var qdd = "";
            var count = 0;
            //grade
            if( grade !== "" && grade !== null ) {
                qdd += grade;
                count++;
            }
            //leaf
            if( leaf !== "" && leaf !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += leaf;
                count++;
            }
            //staple
            if( staple !== "" && staple !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += staple;
                count++;
            }
            //mic
            if( mic !== "" && mic !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += mic;
                count++;
            }
            //strength
            if( strength !== "" && strength !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += strength;
                count++;
            }
            //strengthRange
            if( strengthRange !== "" && strengthRange !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += strengthRange;
                count++;
            }
            //unf
            if( unf !== "" && unf !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += unf;
            }
            //range
            if( range !== "" && range !== null ) {
                if( count > 0 ) {
                    qdd += " ";
                }
                qdd += range;
            }
            return qdd;
        }

        function buildQtyDisplay( qty, unit, altQty, tolType, tol ) {
            var qd = "About ";
            var count = 0;
            if( qty !== "" && qty !== null ) {
                qd += qty;
                count++;
            }
            if( unit !== "" && unit !== null ) {
                if( count > 0 ) {
                    qd += " ";
                }
                qd += unit;
                count++;
            }
            if( tolType !== "" && tolType !== null ) {
                if( count > 0 ) {
                    qd += ", ";
                }
                qd += 'in ' + tolType + ' ' + unit;
                count++;
            }
            if( tol !== "" && tol !== null ) {
                if( count > 0 ) {
                    qd += " ";
                }
                qd += '(' + tolType + ' ' + tol + "%)";
            }
            return qd;
        }

        function toFixed(value, n) {
            var str = value.toFixed(n);
            if (str.indexOf('e+') < 0) {
                return str;
            }

            // if number is in scientific notation, pick (b)ase and (p)ower
            return str.replace('.', '').split('e+').reduce(function(p, b) {
                return p + new Array(b - p.length + 2).join(0);
            }) + '.' + new Array(n + 1).join(0);
        }

        function nl2br( text ) {
            return text.replace(/\n/g, '<br/>');
        }

        function dateFix( date ) {
            var newDateString = "";
            if( date instanceof Date ) {
                newDateString = date.getFullYear() + "/" + ( date.getMonth() + 1 ) + "/" + date.getDate();
            } else {
                newDateString = date.toString().replace(/-/g,'\/').replace(/T.+/,'');
            }
            return new Date( newDateString );
        }

        function generateStartDate( date ) {
            return dateFix(date);
        }

        function generateEndDate( date ) {
            return dateFix(date);
        }

        function onStartDateChange( startDate, endDate ) {
            return startDate > endDate ? dateFix(startDate) : dateFix(endDate);
        }

        function generateLastDayOfMonth( date ) {
            var myDate = dateFix( date );
            return new Date(myDate.getFullYear(), myDate.getMonth()+1, 0);
        }

        function resolveDateStringByFormat(dateString, format) {
            var parts;
            if(dateString.includes("/")) {
                parts = dateString.split('/');
            } else {
                parts = dateString.split('-');
            }
            switch(format) {
                case 'yyyy-mm-dd':
                    var date = new Date(parts[0], parts[1] - 1, parts[2]);
                    return date;
                case 'mm-dd-yyyy':
                    var date = new Date(parts[2], parts[0] - 1, parts[1]);
                    return date;
                case 'dd-mm-yyyy':
                    var date = new Date(parts[2], parts[1] - 1, parts[0]);
                    return date;
            }
        }
    }

})();
